import { useEffect } from 'react';
import sqftConfig from '../../components/canvas/store/sqftConfig';
import useWindowDimensions from '../../hocs/useWindowDimensions';
import store from "../../../../store";
//import {hardCodeIsRenuit} from "../../../../misc/fabricatorHardcode";

const useUpdateSqftConfig = () => {
  const { windowWidth } = useWindowDimensions();
  const state = store.getState();
  const fabricatorSettings = state.fabricatorState.settings;

  useEffect(() => {
    sqftConfig.updateDefaultScale(windowWidth);
    sqftConfig.updateWorkspace(windowWidth);
  }, [windowWidth]);

  useEffect(() => {
    sqftConfig.setScale(sqftConfig.defaultScale);
  }, []);

  useEffect(() => {
    sqftConfig.shouldUseCabinetDoorsSQFT = fabricatorSettings.cabinetSettings === 'SQFT'; //|| hardCodeIsRenuit();
    sqftConfig.shouldUseCabinetDoorsLNFT = fabricatorSettings.cabinetSettings === 'LNFT';
    sqftConfig.shouldUseCabinetDoorsAndDrawersQuantity = fabricatorSettings.cabinetSettings === 'DoorsDrawers';

    sqftConfig.shouldAddCabinetBoxes = fabricatorSettings.cabinetBoxes

  }, [fabricatorSettings]);
};

export default useUpdateSqftConfig;
